import { FC, useEffect, useState } from "react";
import { ModalType, NewDoctorType, NewPracticeType } from "./types";
// import { createAndDownloadExcelFile } from "src/helpers/downloadFile";
import { formatPhoneNumber } from "src/helpers";
import { ColumnSortProps } from "src/components/tableHeader/types";
import { sortTableColumns } from "src/helpers/stats";

import { DOCTOR_TABLE_COLUMNS, PRACTICE_TABLE_COLUMNS } from "src/constants/stats";
import TableHeader from "src/components/tableHeader";


const Modal: FC<ModalType> = ({ title, data, onClick }): JSX.Element => {
  const [dataListing, updateDataListing] = useState<(NewDoctorType | NewPracticeType)[]>([]);
  const [sortingConfig, setSortingConfig] = useState<ColumnSortProps>({
    sort_by: '',
    direction: 'desc',
  });

  const overFlowBackground = ()=>{
    document.body.style.overflow = 'unset';
    onClick()
  }

  useEffect(() => {
    if (data.length > 0) {
      updateDataListing(data)
      setSortingConfig({direction:"desc",sort_by:""})
    }
  }, [data])

  const changeIdOrder = (value: string) => {
    sortTableColumns(value, sortingConfig, setSortingConfig, dataListing, updateDataListing)
  };

  return (
    <div className= {`modal fade loader-index ${title && title.length > 0 ? 'show show-modal' : ''}`} id="typeModal" aria-labelledby="typeModalLabel" aria-hidden="true" >
      <div className="modal-dialog modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header pt-2 pb-2">
            <h4 className="modal-title" id="typeModalLabel" style={{color:'#008853', fontSize:'1.875rem'}}>{title}</h4>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={overFlowBackground}></button>
          </div>

          <div className="modal-body p-0 pt-0">
            {title === "New Practices" ?
              <table className="table table-striped table-hover table-responsive position-relative m-0">
                <thead className="sticky-top text-center">
                  <tr>
                    {PRACTICE_TABLE_COLUMNS.map((header, index) => (
                      <TableHeader 
                        key={index}
                        classNames="fs-6" sortConfig={sortingConfig}
                        changeIdOrder={changeIdOrder} tableHeader={header}
                      />
                    ))}
                  </tr>
                </thead>
                <tbody className={"text-center"}>
                  {dataListing.length > 0 ? dataListing.map((item, index) =>
                    <tr key={index}>
                      {/* <td className="text-17">{index+1}</td> */}
                      <td className="text-17 text-wrap text-break">{item.name || ""}</td>
                      {/* <td className="text-center text-17">{item.npi || ""}</td> */}
                      <td className="text-center text-17">{item.state || ""}</td>
                      {item.phone ? <td className="text-center text-17" style={{minWidth:'145px'}}>{formatPhoneNumber(item?.phone)}</td> : <td></td>}
                    </tr>
                  ) : null}
                </tbody>
              </table>
              :
              <table className="table table-hover table-striped table-responsive m-0">
                <thead className="sticky-top">
                  <tr>
                    {DOCTOR_TABLE_COLUMNS.map((header, index) => (
                      <TableHeader 
                        key={index}
                        classNames="text-center fs-6"
                        sortConfig={sortingConfig}
                        changeIdOrder={changeIdOrder} tableHeader={header}
                      />
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {dataListing.length > 0 ? dataListing.map((item, index) =>
                    <tr  className={"text-center"} key={index}>
                      <td className="text-17 text-wrap text-break">{item.name || ""} </td>
                      <td className="text-17">{(item as NewPracticeType).practice || ""} </td>
                      <td className="text-center text-17">{item.state || ""}</td>
                      {item.phone ? <td className="text-center text-17" style={{minWidth:'145px'}}>{formatPhoneNumber(item?.phone)}</td> : <td></td>}
                    </tr>
                  ) : null}
                </tbody>
              </table>
            }
          </div>

          {/* <div className="modal-footer justify-content-center p-1">
            <button type="button" className="btn btn-primary"
             // onClick={() => createAndDownloadExcelFile(data, title === "New Practices")}
            >
              <i className="bi bi-file-earmark-spreadsheet me-2"></i>
              Download
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Modal;
